import { getContext, setContext } from 'svelte'
import type { Attachment } from 'svelte/attachments'

export interface FlyoutTriggerProps {
  open: boolean
  props: {
    type: 'button'
    disabled: boolean
    'aria-label': string
    'aria-haspopup': 'true'
    'aria-expanded': boolean
    onclick: (event: MouseEvent) => void
    [attachment: symbol]: Attachment<HTMLElement>
  }
}

const FLYOUT_KEY = Symbol('flyout')

export interface FlyoutContext {
  readonly open: boolean
  readonly hoverOpened: boolean
  readonly focusOptions: FocusOptions | undefined
  readonly levelCount: number
  register: () => () => void
}

export function setFlyoutContext(context: FlyoutContext): void {
  setContext(FLYOUT_KEY, context)
}

export function getFlyoutContext(): FlyoutContext {
  const context = getContext<FlyoutContext | undefined>(FLYOUT_KEY)
  if (!context) {
    throw new Error('<FlyoutLevel> can only be used inside a <Flyout>')
  }
  return context
}

const ITEM_SELECTOR = 'button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'

export function focusFirstItem(node: HTMLElement, focusOptions?: FocusOptions): void {
  node.querySelector<HTMLElement>(ITEM_SELECTOR)?.focus(focusOptions)
}
